import React from 'react'
import "./assets/vendor/bootstrap-icons/bootstrap-icons.css"
import "./assets/vendor/boxicons/css/boxicons.css"
import "./assets/js/main";
import About from './components/About'
import Contact from './components/Contact'
import Facts from './components/Facts'
import Footer from './components/Footer'
import Header from './components/Header'
import Hero from './components/Hero'
import Protfolio from './components/Protfolio'
import Services from './components/Services'
import Skills from './components/Skills'
import Testimonials from './components/Testimonials'
import Resume from "./components/Resume"
import {Route, Routes} from "react-router-dom"
import Home from './Home';
import Bar from './components/Bar';
import { AnimatePresence } from 'framer-motion';


function App() {

  return (
    <AnimatePresence>
      <div className="App">
       <Bar/>
 <Routes>
       <Route path="/" element={<Home/>}/>
       <Route path="/hero" element={<Hero/>}/>
       <Route path="/about" element={<About/>}/>
       <Route path="/facts" element={<Facts/>}/>
       <Route path="/skills" element={<Skills/>}/>
       <Route path="/resume" element={<Resume/>}/>
       <Route path="/protfolio" element={<Protfolio/>}/>
       <Route path="/services" element={<Services/>}/>
       <Route path="/testimonials" element={<Testimonials/>}/>
       <Route path="/contact" element={<Contact/>}/>
       <Route path="/footer" element={<Footer/>}/>
 </Routes>
 <script src="./src/assets/js/main.js"></script>
    </div>
    </AnimatePresence>
  )
}

export default App
